import html2canvas from 'html2canvas';
import { useRef, useState, useCallback, Component, createRef } from 'react';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

/**
 * @param options - optional html2canvas Options object
 */
function useCurrentPng(options) {
    const ref = useRef();
    const [isLoading, setIsLoading] = useState(false);
    const getPng = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        var _a;
        if (ref !== null && ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.container)) {
            setIsLoading(true);
            return yield html2canvas(ref.current.container, Object.assign({ logging: false }, options)).then((canvas) => {
                setIsLoading(false);
                return canvas.toDataURL('image/png', 1.0);
            });
        }
    }), [options]);
    return [
        getPng,
        {
            ref,
            isLoading,
        },
    ];
}
class CurrentPng extends Component {
    constructor() {
        super(...arguments);
        this.chartRef = createRef();
        this.state = {
            isLoading: false,
        };
        this.getPng = (options) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if ((_a = this.chartRef.current) === null || _a === void 0 ? void 0 : _a.container) {
                this.setState({ isLoading: true });
                return yield html2canvas(this.chartRef.current.container, Object.assign({}, options)).then((canvas) => {
                    this.setState({ isLoading: false });
                    return canvas.toDataURL('image/png', 1.0);
                });
            }
        });
    }
    render() {
        return this.props.children({
            chartRef: this.chartRef,
            getPng: this.getPng,
            isLoading: this.state.isLoading,
        });
    }
}

export { CurrentPng, useCurrentPng };
//# sourceMappingURL=index.esm.js.map
